var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 9.83341C21.9332 9.83341 23.4998 11.4001 23.4998 13.3334C23.4998 15.2667 21.9332 16.8334 19.9998 16.8334C18.0665 16.8334 16.4998 15.2667 16.4998 13.3334C16.4998 11.4001 18.0665 9.83341 19.9998 9.83341ZM19.9998 24.8334C24.9498 24.8334 30.1665 27.2667 30.1665 28.3334V30.1667H9.83317V28.3334C9.83317 27.2667 15.0498 24.8334 19.9998 24.8334ZM19.9998 6.66675C16.3165 6.66675 13.3332 9.65008 13.3332 13.3334C13.3332 17.0167 16.3165 20.0001 19.9998 20.0001C23.6832 20.0001 26.6665 17.0167 26.6665 13.3334C26.6665 9.65008 23.6832 6.66675 19.9998 6.66675ZM19.9998 21.6667C15.5498 21.6667 6.6665 23.9001 6.6665 28.3334V33.3334H33.3332V28.3334C33.3332 23.9001 24.4498 21.6667 19.9998 21.6667Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c826a3d3d28763396b194882f327c400.svg";
export { ForwardRef as ReactComponent };